import React from 'react';

export default class Values extends React.Component {
  render() {
    let values = this.props.values;
    let headline = this.props.headline;

    let items = values.map((valueEntry, idx) => {
      return (
        <div key={`value-entry-item-${idx}`} className={'value-entry' + (valueEntry.className ? ' ' + valueEntry.className : '')}>
          <div className="value-logo"><img role="presentation" src={valueEntry.imageUrl} /></div>
          <div className="content">
            <h4>{valueEntry.header}</h4>
            <p>{valueEntry.description}</p>
          </div>
        </div>
      );
    });

    let headlineContent = null;
    if (headline) headlineContent = <h2>{headline}</h2>;

    let className = 'values home-section' + (this.props.className ? ' ' + this.props.className : '');

    return (
      <div className={className}>
        <div className="values-inner-wrapper">
          {headlineContent}
          {items}
        </div>
      </div>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/views/Home/Values.js
 **/